import React from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'next/router';
import { track } from '../../analytics/analytics';
import { getNewLinkParams } from './GetNewLinkParams';


const Root = styled.div`
  .page-item {
    margin-bottom: 1rem;
  }

  .page-link {
    border: 2px solid transparent;

    &:hover {
      border-color: rgba(55, 125, 255, 0.2);
    }

    &:focus {
      box-shadow: 0 0 0 2px var(--blue-brdr);
      border-color: var(--blue-brdr);
    }
  }
`;

const addCustomParams = (page) => (query, params) => {
  params.set('p', page);
};

const pageHrefBuilder = router => (page) => {
  const linkParams = getNewLinkParams(router, addCustomParams(page));
  return linkParams.as;
};

class SearchResultsPaginationView extends React.Component {
  onPageChange = (page) => {
    const { router } = this.props;

    const linkParams = getNewLinkParams(router, addCustomParams(page.selected + 1));

    window.scrollTo({ top: 0 });
    router.push(
      linkParams.href,
      linkParams.as,
    );

    this.trackPageChange(page.selected);
  };

  trackPageChange = (page) => {
    track(
      { category: 'Pagination', action: 'Change', label: page },
      { page },
    );
  };

  render() {
    const { search, filter, router } = this.props;
    const { totalPages } = search;
    const { p: page } = filter;

    if (page && totalPages > 1) {
      return (
        <Root>
          <nav aria-label="Pagination">
            <ReactPaginate
              forcePage={page - 1}
              disableInitialCallback
              initialPage={page - 1}
              previousLabel="previous"
              nextLabel="next"
              breakLabel={null} // becomes a link to the current page if not `null`
              pageClassName="page-item"
              previousClassName="page-item"
              activeLinkClassName="active"
              nextClassName="page-item"
              breakClassName="page-item"
              pageLinkClassName="page-link"
              nextLinkClassName="page-link"
              previousLinkClassName="page-link"
              pageCount={totalPages > 100 ? 100 : totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={7}
              onPageChange={this.onPageChange}
              containerClassName="pagination flex-wrap"
              activeClassName="active"
              hrefBuilder={pageHrefBuilder(router)}
            />
          </nav>
        </Root>
      );
    }

    return null;
  }
}

export const SearchResultsPagination = withRouter(SearchResultsPaginationView);

SearchResultsPagination.propTypes = {
  search: PropTypes.shape({
    totalPages: PropTypes.number,
  }),
  filter: PropTypes.shape({
    p: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};


SearchResultsPaginationView.propTypes = {
  ...SearchResultsPagination.propTypes,
  router: PropTypes.shape({
    asPath: PropTypes.string.isRequired,
    query: PropTypes.shape({}).isRequired,
    push: PropTypes.func.isRequired,
  }),
};
